export default "__VITE_ASSET__6yis552e__"